import { useState } from "react";
import { Link } from "react-router-dom";
import { BsEyeFill } from "react-icons/bs";
import { projects } from "../../ProjectData";
import { IoSearch } from "react-icons/io5";

const Showcase = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("");
  
  const handleSearch = (e) => {
    const searchText = e.target.value;
    setSearchTerm(searchText);
    
      
   
  };

  const handleFilterChange = (e) => {
    if (e.target.value === "all") {
      setFilter("");
    } else {
      setFilter(e.target.value);
    }
  };

  const filteredProjects = projects.filter((project) => {
    return (
      project.keys.some((key) =>
        key.toLowerCase().includes(searchTerm.toLowerCase())
      ) &&
      (filter === "" || project.type.toLowerCase() === filter.toLowerCase())
    );
  });
  return (
    <div className="pt-16 flex flex-col z-10 items-center justify-center w-full bg-[#f9f9f9] pb-28 rounded-t-3xl relative bottom-10">
      <div className="flex flex-col items-center justify-center w-full py-3 gap-y-2">
        <h6 className="text-[26px] sm:text-[32px] md:text-[40px] font-bold ">
          {" "}
          My Projects
        </h6>
        <div className="section-line"></div>
        <p className="text-[16px] md:text-[20px] w-[97%] sm:w-[90%] md:w-[65%] lg:w-[55%] xl:w-[47%] text-center text-[#555555]">
          Here, you will find some of the clients and personal projects that I
          created.
        </p>
      </div>
      <div className="flex flex-col-reverse gap-y-3 sm:flex-row items-center justify-between mt-16   sm:w-[96%] lg:w-[92%] xl:w-[82%]">
        {/* search */}
        <div className="flex items-center ml-3 gap-x-2 sm:ml-0">
          <p className="md:text-lg">Search</p>
          <input
            type="text"
            className=" px-2 py-[10px] rounded-lg  bg-[#efefef] outline-none min-w-[210px] sm:min-w-[280px] lg:min-w-[340px] xl:min-w-[400px]"
            onChange={handleSearch}
          />
          <IoSearch
            size={23}
            className="relative text-black cursor-pointer right-9"
          />
        </div>

        {/* filter */}
        <div className="flex items-center gap-x-2">
          <p className="md:text-lg">Filter</p>
          <select
            name="category"
            className="py-[10px] px-2 rounded-md bg-[#efefef] outline-none md:min-w-[140px] lg:min-w-[170px] xl:min-w-[200px]"
            onChange={handleFilterChange}
          >
            <option value="" selected disabled>
              Select
            </option>
            <option value="personal">Personal</option>
            <option value="client">Client</option>
            <option value="all">All</option>
          </select>
        </div>
      </div>

      {/* Project Cards Container */}
      <div className="flex flex-wrap items-center w-full mt-12 justify-around px-2 lg:w-full xl:w-[90%] gap-x-3 gap-y-10 md:gap-y-20">
        {/* card */}
        {filteredProjects.map((item) => (
          <div
            key={item.id}
            className="overflow-hidden transition-all duration-500 bg-white rounded-lg hover:shadow-xl drop-shadow-md shadow-black w-[350px] sm:min-h-[462px] lg:min-h-[430px] xl:min-h-[434px] sm:w-[280px] md:w-[340px] lg:w-[320px] xl:w-[350px]"
          >
            <div className=" min-h-[200px] relative overflow-hidden group transition">
              <div className="flex items-start justify-center w-full h-full">
                {/*  image */}
                <div className="flex items-center justify-center w-full overflow-hidden">
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <img
                      alt=""
                      className="max-h-[230px] group-hover:scale-110 transition object-cover duration-300"
                      src={item.img}
                    />
                  </a>
                </div>
              </div>
              {/* Buttons */}
              <div className="absolute flex flex-col items-center justify-center p-2 transition-all duration-300 lg:opacity-0 top-6 right-5 lg:-right-11 group-hover:right-5 gap-y-2 group-hover:opacity-100">
                <a
                  href={item.link}
                  target="_blank" rel="noopener noreferrer"
                  className="flex items-center justify-center w-10 h-10 text-black bg-white lg:w-12 lg:h-12 hover:text-black drop-shadow-xl"
                  title="See Live"
                >
                  <BsEyeFill className="active:text-black" />
                </a>
              </div>
            </div>
            {/* category & title & price*/}
            <div className="p-3">
              <div className="mb-1 text-sm text-[#555555] capitalize">
                {item.category}
              </div>
              <Link to={`/product/2`} className="hover:text-black">
                <h2 className="mb-1 font-semibold">
                  {item.name}{" "}
                  <span className="font-normal text-[#555555]">
                    {item.detail}
                  </span>
                </h2>
              </Link>
              <div className="font-semibold">{item.type}</div>
              <p className="text-sm font-medium text-gray-500 ">
                {item.desc.length > 250
                  ? item.desc.slice(0, 250) + "..."
                  : item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Showcase;
